import { useOfferFiltersDispatch, useOfferFiltersState, } from "../context/OfferFiltersContext";
import ChevronDownIcon from "./ChevronDownIcon";
import React from "react";
export default function QuickFilterPill({ filterId, }) {
    var _a;
    const { pathFilters, selectedState } = useOfferFiltersState();
    const dispatch = useOfferFiltersDispatch();
    const filter = pathFilters.find((f) => f.id === filterId);
    if (!filter)
        return null;
    const currentValue = selectedState[filterId];
    const hasSelection = currentValue != null && currentValue !== "";
    const currentLabel = (_a = filter.options.find((o) => o.value === currentValue)) === null || _a === void 0 ? void 0 : _a.label;
    function handleClick() {
        dispatch({ type: "open_overlay_focused", payload: { filterId } });
    }
    return (<button type="button" onClick={handleClick} className="flex items-center gap-2 h-10 px-3.5 rounded-full border border-[#A1A2A5] bg-white text-sm whitespace-nowrap">
      <span>{hasSelection ? currentLabel : filter.label}</span>
      <ChevronDownIcon className="size-4 shrink-0 -mr-1"/>
    </button>);
}
